import Moving, { getServerSideProps } from './Moving';
export default Moving;
export { getServerSideProps };
